import React from 'react';
import { Link } from 'react-router-dom';
import { FaRobot, FaTrophy, FaUsers, FaClock, FaArrowRight } from 'react-icons/fa';

const difficultyConfig = {
  easy: {
    gradient: 'from-green-500 to-emerald-600',
    glow: 'shadow-[0_0_15px_rgba(16,185,129,0.5)]',
    textGradient: 'from-green-400 to-emerald-500',
    icon: <FaRobot className="mr-1" />
  },
  medium: {
    gradient: 'from-yellow-500 to-amber-600',
    glow: 'shadow-[0_0_15px_rgba(245,158,11,0.5)]',
    textGradient: 'from-yellow-400 to-amber-500',
    icon: <FaRobot className="mr-1" />
  },
  hard: {
    gradient: 'from-red-500 to-rose-600',
    glow: 'shadow-[0_0_15px_rgba(244,63,94,0.5)]',
    textGradient: 'from-red-400 to-rose-500',
    icon: <FaRobot className="mr-1" />
  }
};

const QuestCard = ({ quest }) => {
  const {
    _id,
    title,
    difficulty,
    reward,
    participantLimit,
    participants,
    description,
    timeLimit,
    image
  } = quest;

  // For backward compatibility, some components might still use 'name'
  const name = title;

  const diffStyle = difficultyConfig[difficulty] || difficultyConfig.medium;

  return (
    <div className="fancy-card group h-full flex flex-col">
      {/* Card Image */}
      <div className="relative overflow-hidden rounded-t-xl h-48">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-dark-800/90 z-10"></div>
        <img
          src={image || "https://placehold.co/400x200/472069/ffffff?text=BitPool+Quest"}
          alt={name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className={`absolute top-4 right-4 text-white px-3 py-1 rounded-full text-sm font-semibold bg-gradient-to-r ${diffStyle.gradient} ${diffStyle.glow} z-20`}>
          <div className="flex items-center">
            {diffStyle.icon}
            {difficulty.charAt(0).toUpperCase() + difficulty.slice(1)}
          </div>
        </div>
      </div>

      {/* Card Content */}
      <div className="p-6 flex flex-col flex-grow">
        {/* Card Title */}
        <div className="mb-4">
          <h3 className="text-xl font-bold text-white mb-2">
            Agent {name.split(' - ')[0]} - Quest
          </h3>
          <p className="text-gray-400 text-sm line-clamp-1">
            BitPool {name.split(' - ')[0]} AI Agent Quest
          </p>
        </div>

        {/* Reward and Players */}
        <div className="grid grid-cols-2 gap-4 mb-6">
          <div>
            <div className="flex items-center text-purple-400 mb-1">
              <FaTrophy className="mr-2" />
              <span className="text-xs text-gray-400">Reward</span>
            </div>
            <div className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-violet-400 to-purple-500">
              {reward?.amount || '0'} {reward?.currency || 'BAI'}
            </div>
          </div>

          <div>
            <div className="flex items-center text-purple-400 mb-1">
              <FaUsers className="mr-2" />
              <span className="text-xs text-gray-400">Played</span>
            </div>
            <div className="text-xl font-bold text-white">
              {quest.totalPlaysCount || '0'}
            </div>
          </div>
        </div>

        {/* View Quest Button */}
        <div className="mt-auto">
          <Link
            to={`/quests/${_id}`}
            className="group-hover:glow-button block w-full bg-gradient-to-r from-violet-600/80 to-purple-600/80 hover:from-violet-500 hover:to-purple-500 text-white font-bold py-3 px-4 rounded-lg text-center transition-all duration-300 relative overflow-hidden"
          >
            <span className="flex items-center justify-center">
              View Quest
              <FaArrowRight className="ml-2 transform transition-transform duration-300 group-hover:translate-x-1" />
            </span>
          </Link>
        </div>
      </div>

      {/* Glow Effect on Hover */}
      <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-violet-500/0 to-purple-600/0 opacity-0 group-hover:from-violet-500/10 group-hover:to-purple-600/10 group-hover:opacity-100 transition-all duration-500 pointer-events-none"></div>
    </div>
  );
};

export default QuestCard;
